import { allTrackers } from "app/services/track/track";

import createExtensionManagementTrackingService from "./factory";

const extensionManagementTrackingService = createExtensionManagementTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default extensionManagementTrackingService;
